module.exports = __webpack_public_path__ + "static/media/xray.b3feef79.jpg";